import moment from 'moment'
import { Component } from 'react'
import dashboardApi from 'services/api/dashboard'

import LoyaltyIcon from '../../components/ReusableComponents/Arrivals/LoyaltyIcon/index'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import styles from './GuestDetails.module.scss'
import { ReactComponent as Booked } from './images/booked.svg'
import { ReactComponent as Calendar } from './images/calendar.svg'
import { ReactComponent as Clicked } from './images/clicked.svg'
import { ReactComponent as Guest } from './images/guest.svg'
import { ReactComponent as Location } from './images/location.svg'
import { ReactComponent as NextAction } from './images/nextAction.svg'
import { ReactComponent as Phone } from './images/phone.svg'
import { ReactComponent as SentText } from './images/sentText.svg'
import { ReactComponent as Shared } from './images/shared.svg'

class GuestDetails extends Component {
  state = {
    isLoading: true,
    isErrored: false
  }

  getGuestDetails = async () => {
    try {
      const guestDetails = await dashboardApi.getSingleUserLog(this.props.guestId)

      if (!guestDetails) {
        this.setState({
          isErrored: true
        })
        return
      }

      const { activityFacts: timelineData, subscriberQuickFacts: guestData } =
        guestDetails.result

      this.setState({
        timelineData,
        guestData,
        isLoading: false,
        isErrored: false
      })
    } catch (error) {
      this.setState({
        isErrored: true,
        isLoading: false
      })
    }
  }

  componentDidMount() {
    this.getGuestDetails()
  }

  render() {
    const { timelineData, guestData, isLoading, isErrored } = this.state
    const { timelineOnly } = this.props

    if (timelineOnly && !timelineData) {
      return null
    }

    if (timelineOnly && !isLoading && !isErrored)
      return (
        <Timeline>
          {timelineData.reverse().map(timeline => (
            <TimelineCard
              {...timeline}
              key={`tc-${timeline.activityDateTime}${timeline.activity}`}
            />
          ))}
        </Timeline>
      )
    return (
      <div className={styles.guestDetails}>
        {isLoading && <LoadingIndicator />}
        {isErrored && <div>Something went wrong while getting guest details.</div>}
        {!isLoading && !isErrored && (
          <>
            <div className={styles.subtitle}>Subscriber details</div>
            <h1 className={styles.h1}>
              <LoyaltyIcon
                loyaltyProgram={guestData.loyaltyProgram}
                loyaltyLevel={guestData.loyaltyLevel}
                className={styles.loyaltyIcon}
              />
              {guestData.fullName}
            </h1>
            <div className={styles.cols}>
              <Timeline>
                {timelineData.reverse().map(timeline => (
                  <TimelineCard
                    {...timeline}
                    key={`tc-${timeline.activityDateTime}${timeline.activity}`}
                  />
                ))}
              </Timeline>
              {!timelineOnly && <Details {...guestData} />}
            </div>
          </>
        )}
        <span className={styles.timezoneNote}>
          Times and dates are in guest local time.
        </span>
      </div>
    )
  }
}

const Timeline = ({ children }) => {
  return (
    <div className={styles.timelineCol}>
      <h2 className={styles.h2}>Timeline</h2>
      <div className={styles.timeline}>{children}</div>
    </div>
  )
}

const TimelineCard = ({ activity, activityDateTime, contentCategory }) => {
  return (
    <div className={styles.timelineCard}>
      <figure>
        {activity === 'Shared' && <Shared />}
        {activity === 'Booked' && <Booked />}
        {activity === 'Clicked' && <Clicked />}
        {activity === 'Scheduled' && <NextAction />}
        {activity === 'Delivered' && <SentText />}
      </figure>
      <div className={styles.timelineCardDate}>
        <span>{moment(activityDateTime).format('MMM D')}</span>
        <small>{moment(activityDateTime).format('h:mm A')}</small>
      </div>
      <div className={styles.timelineCardDetail}>
        <span>{getActivityNameText(activity)}</span>
        {contentCategory && <small>{contentCategory} campaign</small>}
      </div>
    </div>
  )
}

const getActivityNameText = activityName => {
  switch (activityName) {
    case 'Scheduled':
      return 'Planned next text'

    case 'Clicked':
      return 'Clicked on link'

    default:
      return activityName
  }
}

const Details = ({ addedOn, fullName, phoneNumber, location, lastCheckOut }) => {
  return (
    <div className={styles.detailsCol}>
      <h2 className={styles.h2}>Details</h2>
      <div className={styles.details}>
        <DetailsCard type="date" title="Added on">
          {moment(addedOn).format('MMM D, YYYY')}
        </DetailsCard>
        <DetailsCard type="name" title="Full name">
          {fullName}
        </DetailsCard>
        <DetailsCard type="phone" title="Phone">
          {phoneNumber}
        </DetailsCard>
        <DetailsCard type="location" title="Location">
          {location}
        </DetailsCard>
        <DetailsCard type="date" title="Last booking">
          {moment(lastCheckOut).format('MMM D, YYYY')}
        </DetailsCard>
      </div>
    </div>
  )
}

const DetailsCard = ({ type, title, children: value }) => {
  return (
    <div className={styles.detailsCard}>
      <figure>
        {type === 'date' && <Calendar />}
        {type === 'name' && <Guest />}
        {type === 'phone' && <Phone />}
        {type === 'location' && <Location />}
      </figure>
      <div className={styles.detailsCardTitle}>{title}</div>
      <div className={styles.detailsCardValue}>{value}</div>
    </div>
  )
}

export default GuestDetails
